class ImportEntitiesService {
  constructor(apiService) {
    this.apiService = apiService;
  }

  upload(formData) {
    return this.apiService.uploadMultiple('/api/v1/import/requests', formData);
  }

  getPage(params) {
    return this.apiService.get('/api/v1/import/requests', params);
  }

  getImportInProgress() {
    return this.apiService.get('/api/v1/import/requests/in-progress');
  }

  getImportRequestById(id) {
    return this.apiService.get(`/api/v1/import/requests/${id}`);
  }

  deleteImportRequests(params) {
    return this.apiService.delete('/api/v1/import/requests', params);
  }
}

export default ImportEntitiesService;
